export class Region {
    _id: string;
    name: string;
    createdDate: Date;
}